export default __webpack_public_path__ + "static/nodejs-5a3a9ca294db0539884810b6e6eafedd.svg";